import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  campaign: [],
  segment_list: [],
  selected_segments: null
};
export const displayAdsSlice = createSlice({
  name: "displayAdsSlice",
  initialState: initialState,
  reducers: {
    updateCampaign: (state, action) => {
      state.campaign = action.payload;
    },
    updateSelectedSegments: (state,action) => {
      state.selected_segments = action.payload;
    },
    updateSegmentList: (state, action) => {
      state.segment_list = action.payload;
    },
    resetdisplayAds: () => initialState
  },
});

export const {
  updateCampaign,
  updateSegmentList,
  updateSelectedSegments,
  resetdisplayAds
} = displayAdsSlice.actions;
export default displayAdsSlice.reducer;
